import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
      { path: '/', component: require(page+'home.vue').default },
      { path: '/nosotros', component: require(page+'about-us/index.vue').default, meta:{title:"Nosotros"}},
      { path: '/distribuidores', component: require(page+'dealers/index.vue').default, meta:{title:"Distribuidores"}},
      // { path: '/preguntas-frecuentes/:table?', component: require(page+'faqs/index.vue').default, meta:{title:"Preguntas frecuentes"}},
      { path: '/ubicaciones-y-sucursales', component: require(page+'branch-offices/index.vue').default, meta:{title:"Sucursales"}},
      { path: '/servicios', component: require(page+'services/index.vue').default, meta:{title:"Servicios"}},
      { path: '/facturacion-electronica', component: require(page+'facturacion-electronica/index.vue').default, meta:{title:"Facturación electrónica"}},
      { path: '/metodos-de-pago', component: require(page+'payment-options/index.vue').default, meta:{title:"Metodos de pago"}},

      { path: '/aviso-de-privacidad', component: require(page+'text-page/aviso.vue').default, meta:{title:"Aviso de Privacidad"}},
      { path: '/terminos-y-condiciones', component: require(page+'text-page/terminos.vue').default, meta:{title:"Términos y condiciones"}},
      { path: '/politica-de-devoluciones', component: require(page+'text-page/politica-devoluciones.vue').default, meta:{title:"Política de Devoluciones"}},
      { path: '/politica-de-envios-a-domicilio', component: require(page+'text-page/politica-de-envios-a-domicilios.vue').default, meta:{title:"Política de envíos a domicilios"}},

      { path: '/hagalo-usted-mismo', component: require(page+'videos/index.vue').default, meta:{title:"Hágalo usted mismo"}},
      { path: '/hagalo-usted-mismo/:id', component: require(page+'videos/results.vue').default, meta:{title:"Hágalo usted mismo"}},

      { path: '/bolsa-de-trabajo', component: require(page+'bolsa-de-trabajo/index.vue').default, meta:{title:"Bolsa de trabajo"}},
      { path: '/bolsa-de-trabajo/categoria/:id', component: require(page+'bolsa-de-trabajo/results.vue').default, meta:{title:"Bolsa de trabajo"}},
	    { path: '/bolsa-de-trabajo/:id', component: require(page+'bolsa-de-trabajo/detail.vue').default, meta:{title:"Bolsa de trabajo"}},
      //   { path: '/politicas-de-pago', component: require(page+'text-page/politicaspago.vue').default, meta:{title:"Politicas de pago"}},
      //   { path: '/politicas-de-envio', component: require(page+'text-page/politicasenvio.vue').default, meta:{title:"Politicas de envio"}},
      { path: '/contacto', component: require(page+'contact/index.vue').default, name: 'contacto', meta:{title:"Contacto"}},
      { path: '/tu-experiencia', component: require(page+'about-your-experience/index.vue').default, meta:{title:"Platícanos tu experiencia de compra"}},

      { path: '/productos', component: require(page+'products/results.vue').default, meta:{title:"Productos"}},
      { path: '/promociones', component: require(page+'products/novedades.vue').default, meta:{title:"Promociones"}},
	  { path: '/promociones/:id?', component: require(page+'products/promotions.vue').default, meta:{title:"Promociones"}},
      { path: '/producto/:id?', component: require(page+'products/description.vue').default, meta:{title:"Producto"}},
      { path: '/categoria/:id?', component: require(page+'products/category.vue').default, meta:{title:"Categoria"}},
      { path: '/busqueda', component: require(page+'products/results.vue').default, meta:{title:"Busqueda"}},
      { path: '/marca/:id?', component: require(page+'products/brand.vue').default, meta:{title:"Marca"}},

      { path: '/cart/:step?', component: require(page+'carrito/index.vue').default, meta:{title:"Mi carrito de compras"}},
      { path: '/historial-de-compras', component: require(page+'carrito/historial.vue').default, meta:{title:"Mi historial de compras"}},
      // { path: '/mis-favoritos', component: require(page+'carrito/mis-favoritos.vue').default, meta:{title:"Mis favoritos"}},

      { path: '/login', component: require(page+'user-access/login.vue').default, meta:{title:"Iniciar sesión"}},
      { path: '/recuperar-contrasena', component: require(page+'user-access/reset-password.vue').default, meta:{title:"Recuperar contraseña"}},
      { path: '/registrarse', component: require(page+'user-access/register.vue').default, meta:{title:"Registrarse"}},

      { path: '/usuario', component: require(page+'usuario-cuenta/index.vue').default, meta:{ title: 'Mi datos' },
  			children: [
  			{
  				path: '/',
  				component: require(page+'usuario-cuenta/mis-datos.vue').default,
  				meta:{ title: 'Mis datos' }
  			},
  			{
  				path: 'contrasena',
  				component: require(page+'usuario-cuenta/contrasena.vue').default,
  				meta:{ title: 'Cambiar contraseña' }
  			},
			{
				path: 'historial-compras',
				component: require(page+'usuario-cuenta/historial-compras.vue').default,
				meta:{ title: 'Mis pedidos' }
			},
			{
				path: 'pedido/:id',
				component: require(page+'usuario-cuenta/orderdetails.vue').default,
				meta:{ title: 'Mis pedidos' }
			},
  	  	]
  		}

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},50);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Durán – Maderas | Ferretería | Plomería", filter: (title)=>{ return title+" - Durán – Maderas | Ferretería | Plomería"; } }
);

// export {routes};
export default MyRouter;
